import { render } from "./PetitionStat.vue?vue&type=template&id=0e98b967"
import script from "./PetitionStat.vue?vue&type=script&lang=js"
export * from "./PetitionStat.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/src/public-poll/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__